import domain from "./domain";
import classes from "./FeedbackForm.module.css";
import { useLoaderData, useParams } from "react-router-dom";

import { Suspense } from "react";
import { defer } from "react-router-dom";
import { Await } from "react-router-dom";
import FeedbackFormComponent3 from "./components/FeedbackFormComponent3";

export default function FeedbackForm3() {
  const params = useParams();

  const id = params.id;
  const { events } = useLoaderData();
  const loadingComponent = (
    <div className={classes.loadingContainer}>
      <div className={classes.loadingContent}>
        <p>Hope You Enjoyed our Service. </p>
        <p>Loading...</p>
      </div>
    </div>
  );
  return (
    <>
      <Suspense fallback={loadingComponent}>
        <Await resolve={events}>
          {(loadedEvents) => (
            <> 
            
              <FeedbackFormComponent3 data={loadedEvents} id={id} />
            </>
          )}
        </Await>
      </Suspense>
    </>
  );
}

export async function loader({ params }) {
  let id = params.id;

  return defer({
    events: loadEvents(id),
  });
}

async function loadEvents(id) {
  try {
    const data1 = await fetch(`${domain}/api/fetchfeedback/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await data1.json();
    console.log("From fetch feedback api",data);
    return data;
  } catch (err) {
    return {
      errorMessage: "Failed to fetch data",
    };
  }
}
